import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const ProductContext = createContext();

const ProductProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [prod, setProd] = useState([]);

    const getProd = async (searchString) => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}call-third-party`,
                {
                    params: {
                        url: `${process.env.REACT_APP_BOND_API_URL}WService=BondWSLive/SWDB/jgat0000.w`,
                        body: {
                            Event: "search",
                            UserId: "MV00008",
                            APIKey: "bFjncidncrcbElCm",
                            CustomerInformation: {
                                AccountNumber: "MV00008"
                            },
                            SearchCriteria: {
                                SearchString: searchString,
                                DeliveryMethod: "Deliver",
                                InStockOnly: true,
                                FullAttributes: false,
                                Pagination: 50,
                                ResultSet: 1,
                            },
                        },
                    },
                }
            );
            const results = res.data?.data?.Response?.Results || [];
            setProd(results);
            return results;
        } catch (error) {
            console.log("Product Fetching Error:", error.response?.data || error.message);
            return [];
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     getProd();
    // }, []);

    return (
        <ProductContext.Provider value={{ prod, loading, getProd }}>
            {children}
        </ProductContext.Provider>
    );
};

const useProductContext = () => useContext(ProductContext);

export { ProductProvider, useProductContext };
